import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SvgStar = ({ className, ...props }) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    height="18"
    width="18"
    className={classNames('svg', 'svg-star', className)}
    {...props}>
    <polygon points="18,4 21.5,14.7 32.8,14.7 23.6,21.3 27.1,32 18,25.4 8.9,32 12.4,21.3 3.2,14.7 14.5,14.7 " />
  </svg>
);

SvgStar.propTypes = {
  className: PropTypes.string,
};

export default SvgStar;
